import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

import AloButton from '../../AloButton'

class CancellationOfferModal extends React.Component {
  render () {
    let body, footer
    if (this.props.eligible) {
      body = (
        <React.Fragment>
          <p dangerouslySetInnerHTML={{ __html: this.props.message }}></p>
          <p className='modal-subcaption'>{this.props.subcaption}</p>
        </React.Fragment>
      )

      footer = (
        <React.Fragment>
          <AloButton
            onClick={this.props.onConfirmCancel}
            disabled={!!this.props.action}
            processing={this.props.action === 'cancel'}
            className={this.props.eligible ? 'cancel' : ''}
            link
          >
            Cancel Membership
          </AloButton>

          <AloButton
            onClick={this.props.onAcceptOffer}
            disabled={!!this.props.action}
            processing={this.props.action === 'accept'}
          >
            I Want To Stay
          </AloButton>
        </React.Fragment>
      )
    } else {
      body = (
        <p>You are about to cancel your membership.</p>
      )

      footer = (
        <AloButton
          onClick={this.props.onConfirmCancel}
          disabled={!!this.props.action}
          processing={this.props.action === 'cancel'}
        >
          Cancel Membership
        </AloButton>
      )
    }

    return (
      <Modal show={this.props.show} onHide={this.props.onHide} className='modal-confirm'>
        <Modal.Header closeButton>
          <Modal.Title>
            {this.props.eligible ? 'Before You Go...' : 'Cancel Membership'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {body}
        </Modal.Body>

        <Modal.Footer>
          {this.props.error &&
            <div className='CancellationOfferModal__error' role='alert'>
              {this.props.error}
            </div>
          }
          {footer}
        </Modal.Footer>
      </Modal>
    )
  }
}

CancellationOfferModal.defaultProps = {
  message: 'Could <b>one free month</b> on us change your mind?'
}

CancellationOfferModal.propTypes = {
  eligible: PropTypes.bool,
  message: PropTypes.string,
  subcaption: PropTypes.string,
  show: PropTypes.bool,
  onHide: PropTypes.func.isRequired,
  onConfirmCancel: PropTypes.func.isRequired,
  onAcceptOffer: PropTypes.func.isRequired,
  error: PropTypes.string,
  action: PropTypes.string
}

export default CancellationOfferModal
